import React from 'react';
import Card from 'material-ui/Card';
import CardActions from 'material-ui/Card/CardActions';
import CardContent from 'material-ui/Card/CardContent';
import Box from '@material-ui/core/Box';

const GridCard = props => {
    const { category, cardMedia, cardIconClass, cardActionButtons } = props;
    return (
        <Card className="card" key={category.key}>
            {cardMedia}
            <CardContent className="card-content">
                <Box>
                    <h3>{category.title}</h3>
                    <p>{category.description}</p>
                </Box>
                <Box className="card-icon">
                    <i className={cardIconClass} />
                </Box>
            </CardContent>
            <CardActions className="card-actions">
                {cardActionButtons}
            </CardActions>
        </Card>
    );
};

export default GridCard;



// WEBPACK FOOTER //
// ./src/view/common/component/GridCard.jsx